/** @format */

import axios from "axios";
import { useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import { Layout, Menu, Dropdown, Space } from "antd";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { DownOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";

import home from "../../../icons/home.png";
import drop from "../../../icons/drop.png";
import logo from "../../../icons/Gerb.webp";
import circle from "../../../icons/circle1.png";
import halfcub from "../../../icons/halfcub.png";
import handdrop from "../../../icons/handdrop.png";
import dashboard from "../../../icons/dashboard.png";
import arrowleft from "../../../icons/arrowleft.png";
import arrowright from "../../../icons/arrowright.png";
import { header } from "../../../components/api/Header";
import { exit } from "../../../components/functions/Exit";
import { user_data } from "../../../components/functions/usr";
import { setDistricts } from "../../../redux/actions/dateActions";
import { getEnv } from "../../../lib/env";

const { Header, Sider, Content } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

let sideMenu = [];
const region = user_data() ? user_data().region_id : 1;

if (region !== 18) {
  sideMenu = [
    getItem(
      <NavLink to="/">Bosh sahifa</NavLink>,
      "1",
      <span role="img" className="sidebar-icon">
        <img src={dashboard} alt="404" />
      </span>
    ),
    getItem(<hr style={{ borderColor: "#eee" }} />, "just-label"),
    region != 1 && region != 6
      ? getItem(
          <NavLink to="suvomborlari">Suv omborlari</NavLink>,
          "4",
          <span role="img" className="sidebar-icon">
            <img src={home} alt="404" />
          </span>
        )
      : null,
    getItem(
      <NavLink to="aqllisuv">Aqlli suv</NavLink>,
      "5",
      <span role="img" className="sidebar-icon">
        <img src={drop} alt="404" />
      </span>
    ),
    region != 16
      ? getItem(
          "Balanslar",
          "6",
          <span role="img" className="sidebar-icon">
            <img src={circle} alt="404" />
          </span>,
          [
            [1, 3, 5, 6, 10, 13, 14].includes(region)
              ? getItem(
                  <NavLink to="amudaryo">- Amudaryo balansi</NavLink>,
                  "7"
                )
              : null,
            [2, 4, 7, 9, 11, 12, 15].includes(region)
              ? getItem(
                  <NavLink to="sirdaryo">- Sirdaryo balansi</NavLink>,
                  "8"
                )
              : null,
            [4, 5, 6, 8].includes(region)
              ? getItem(
                  <NavLink to="zarafshon">- Zarafshon balansi</NavLink>,
                  "9"
                )
              : null,
          ]
        )
      : null,
    // region < 14
    //   ? getItem(
    //       <NavLink to="suvdanfoydalanish">Suvdan foydalanish</NavLink>,
    //       "10",
    //       <span role="img" className="sidebar-icon">
    //         <img src={handdrop} alt="404" />
    //       </span>
    //     )
    //   : null,
    getItem(
      <NavLink to="asosiymanbalar">Asosiy manbalar </NavLink>,
      "11",
      <span role="img" className="sidebar-icon">
        <img src={halfcub} alt="404" />
      </span>
    ),
    [4, 5, 6, 8].includes(region)
      ? getItem(
          <NavLink to="ravotxoji">Ravotxoji g/u</NavLink>,
          "12",
          <span role="img" className="sidebar-icon">
            <img src={halfcub} alt="404" />
          </span>
        )
      : null,
    [4, 9, 11, 16].includes(region)
      ? getItem(
          <NavLink to="oqjarqizilqishloq">Oqjar va Qizilqishloq</NavLink>,
          "13",
          <span role="img" className="sidebar-icon">
            <img src={halfcub} alt="404" />
          </span>
        )
      : null,
    [2, 7, 12, 15].includes(region)
      ? getItem(
          <NavLink to="reykauchqurgon">02 Reyka va Uchqurg’on</NavLink>,
          "14",
          <span role="img" className="sidebar-icon">
            <img src={halfcub} alt="404" />
          </span>
        )
      : null,
    // ![14, 15].includes(region)
    //   ? getItem(
    //       "Sug’orish",
    //       "15",
    //       <span role="img" className="sidebar-icon">
    //         <img src={halfcub} alt="404" />
    //       </span>,
    //       [
    //         getItem(<NavLink to="vegitatsiya">- Vegitatsiya</NavLink>, "16"),
    //         getItem(
    //           <NavLink to="novegitatsiya">- Novegitatsiya</NavLink>,
    //           "17"
    //         ),
    //       ]
    //     )
    //   : null,
    // ![14, 15].includes(region)
    //   ? getItem(
    //       "Limit",
    //       "21",
    //       <span role="img" className="sidebar-icon">
    //         <img src={halfcub} alt="404" />
    //       </span>,
    //       [
    //         getItem(<NavLink to="/limit/ptn">- Ptn</NavLink>, "22"),
    //         getItem(<NavLink to="/limit/manbalar">- Manbalar</NavLink>, "23"),
    //         getItem(
    //           <NavLink to="/limit/daryolar">- Daryo havzalari</NavLink>,
    //           "24"
    //         ),
    //       ]
    //     )
    //   : null,
    ![14, 15].includes(region)
      ? getItem(
          <NavLink to="statistik">Statistik hisobotlar</NavLink>,
          "19",
          <span role="img" className="sidebar-icon">
            <img src={halfcub} alt="404" />
          </span>
        )
      : null,
    // ![14, 15].includes(region)
    //   ? getItem(
    //       "SFR",
    //       "20",
    //       <span role="img" className="sidebar-icon">
    //         <img src={halfcub} alt="404" />
    //       </span>
    //     )
    //   : null,
  ];
} else {
  sideMenu = [
    getItem(
      <NavLink to="asosiymanbalar">Uzgidromet markazi</NavLink>,
      "12",
      <span role="img" className="sidebar-icon">
        <img src={halfcub} alt="404" />
      </span>
    ),
    // getItem(<NavLink to="asosiymanbalar">Asosiy manbalar </NavLink>, '11', <span role="img" className="sidebar-icon"><img src={halfcub} alt="404"/></span>),
  ];
}

// const headerMenu = [
//   getItem(
//     "Suv omborlari",
//     "1",
//     <span role='img' className='sidebar-icon'>
//       <img src={location} alt='404' />
//     </span>
//   ),
//   getItem(
//     "Amudaryo",
//     "2",
//     <span role='img' className='sidebar-icon'>
//       <img src={location} alt='404' />
//     </span>
//   ),
//   getItem(
//     "Sirdaryo",
//     "3",
//     <span role='img' className='sidebar-icon'>
//       <img src={location} alt='404' />
//     </span>
//   ),
//   getItem(
//     "Zarafshon daryosi",
//     "4",
//     <span role='img' className='sidebar-icon'>
//       <img src={location} alt='404' />
//     </span>
//   ),
//   getItem(
//     "Manbalar",
//     "5",
//     <span role='img' className='sidebar-icon'>
//       <img src={location} alt='404' />
//     </span>
//   ),
// ];

const items = [
  getItem("Profil", "1", <UserOutlined style={{ color: "#6993FF" }} />),
  {
    key: "2",
    label: (
      <span
        className=""
        style={{ fontSize: "13px" }}
        rel="noopener noreferrer"
        onClick={() => exit()}
      >
        Chiqish
      </span>
    ),
    icon: <LogoutOutlined style={{ color: "#db0909" }} />,
  },
];

const MainLayout = ({ date, setDate }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [ldate, setLdate] = useState(date);
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const getDistricts = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        getEnv('REACT_APP_BASE_URL') + "/v1/region/districts/index",
        header()
      );
      if (res.data) {
        dispatch(setDistricts(res.data));
      }
    } catch (err) {
      console.log("Error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDistricts();
  }, []);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <Layout>
      <Sider width={265} trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          {collapsed ? "SM" : "SMARTWATER"}
          {React.createElement(
            collapsed
              ? () => (
                  <span
                    className="logo-icon"
                    onClick={() => setCollapsed(!collapsed)}
                  >
                    <img src={arrowright} alt="404" />
                  </span>
                )
              : () => (
                  <span
                    className="logo-icon"
                    onClick={() => setCollapsed(!collapsed)}
                  >
                    <img src={arrowleft} alt="404" />
                  </span>
                )
          )}
        </div>

        <Menu
          className="sidebar-menu upper"
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={sideMenu}
        />
      </Sider>

      <Layout className="site-layout">
        <Header
          className="site-layout-background top-menu"
          style={{ padding: 0, height: "64px" }}
          mode="horizontal"
        >
          <div className="ps-3 d-flex">
            <div>
              <img height="70%" src={logo} alt="404" />
            </div>

            <div className="ps-2 d-flex align-items-center">
              <h4
                className="m-0 text-uppercase"
                style={{ lineHeight: "20px", color: "#fff" }}
              >
                O'zbekiston Respublikasi Suv xo'jaligi vazirligi
              </h4>
            </div>
          </div>

          <div className="dropdown-style">
            <ul>
              {location.pathname === "/" ? (
                <li className="d-flex align-items-center">
                  <div className="d-flex" style={{ height: "36px" }}>
                    <input
                      className="form-control form-control-sm"
                      type="date"
                      onChange={(e) => setLdate(e.target.value)}
                      value={ldate}
                    />
                  </div>
                </li>
              ) : null}
            </ul>

            <Dropdown menu={{ items }}>
              <button
                className="btn"
                style={{ border: "#fff !important", color: "#fff" }}
                onClick={(e) => e.preventDefault()}
              >
                <Space className="dropdown-btn">
                  {JSON.parse(localStorage.getItem("sw_user")).fio}
                  <span style={{ position: "absolute", top: "20px" }}>
                    <DownOutlined />
                  </span>
                </Space>
              </button>
            </Dropdown>
          </div>
        </Header>

        <Content className="site-layout-background">
          <Outlet context={[collapsed]} />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
